/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.14.8.0 (NJsonSchema v10.5.2.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import { DateTime, Duration } from "luxon";

export const API_UI_GRPC_SERVER_URL = new InjectionToken<string>('API_UI_GRPC_SERVER_URL');

@Injectable()
export class V1ServiceProxy {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_UI_GRPC_SERVER_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * @return Success
     */
    getAllPayments(sessionId: string, clientId: string, locationId: string) : Observable<GetAllPaymentsResponse> {
        let url_ = this.baseUrl + "/v1/getAllPayments/{sessionId}/{clientId}/{locationId}";
        if (sessionId === undefined || sessionId === null)
            throw new Error("The parameter 'sessionId' must be defined.");
        url_ = url_.replace("{sessionId}", encodeURIComponent("" + sessionId));
        if (clientId === undefined || clientId === null)
            throw new Error("The parameter 'clientId' must be defined.");
        url_ = url_.replace("{clientId}", encodeURIComponent("" + clientId));
        if (locationId === undefined || locationId === null)
            throw new Error("The parameter 'locationId' must be defined.");
        url_ = url_.replace("{locationId}", encodeURIComponent("" + locationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllPayments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllPayments(<any>response_);
                } catch (e) {
                    return <Observable<GetAllPaymentsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetAllPaymentsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllPayments(response: HttpResponseBase): Observable<GetAllPaymentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllPaymentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let resultdefault: any = null;
            let resultDatadefault = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            resultdefault = Status.fromJS(resultDatadefault);
            return throwException("Error", status, _responseText, _headers, resultdefault);
            }));
        }
    }
}

export class Any implements IAny {
    type!: string;

    constructor(data?: IAny) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["@type"];
        }
    }

    static fromJS(data: any): Any {
        data = typeof data === 'object' ? data : {};
        let result = new Any();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["@type"] = this.type;
        return data; 
    }
}

export interface IAny {
    type: string;
}

export class ComboBoxItemUuidValue implements IComboBoxItemUuidValue {
    name!: string;
    id!: string;

    constructor(data?: IComboBoxItemUuidValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ComboBoxItemUuidValue {
        data = typeof data === 'object' ? data : {};
        let result = new ComboBoxItemUuidValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data; 
    }
}

export interface IComboBoxItemUuidValue {
    name: string;
    id: string;
}

export class FieldGrandTotal implements IFieldGrandTotal {
    fieldName!: string;
    grandTotal!: string;

    constructor(data?: IFieldGrandTotal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fieldName = _data["fieldName"];
            this.grandTotal = _data["grandTotal"];
        }
    }

    static fromJS(data: any): FieldGrandTotal {
        data = typeof data === 'object' ? data : {};
        let result = new FieldGrandTotal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fieldName"] = this.fieldName;
        data["grandTotal"] = this.grandTotal;
        return data; 
    }
}

export interface IFieldGrandTotal {
    fieldName: string;
    grandTotal: string;
}

export class GetAllPaymentsResponse implements IGetAllPaymentsResponse {
    payments!: ViewHistoryPayment[];
    dataAsOf!: string;
    locations!: ComboBoxItemUuidValue[];
    blAndGrpcLogger!: string[];
    grandTotals!: FieldGrandTotal[];
    exceptionMessage!: string;

    constructor(data?: IGetAllPaymentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(ViewHistoryPayment.fromJS(item));
            }
            this.dataAsOf = _data["dataAsOf"];
            if (Array.isArray(_data["locations"])) {
                this.locations = [] as any;
                for (let item of _data["locations"])
                    this.locations!.push(ComboBoxItemUuidValue.fromJS(item));
            }
            if (Array.isArray(_data["blAndGrpcLogger"])) {
                this.blAndGrpcLogger = [] as any;
                for (let item of _data["blAndGrpcLogger"])
                    this.blAndGrpcLogger!.push(item);
            }
            if (Array.isArray(_data["grandTotals"])) {
                this.grandTotals = [] as any;
                for (let item of _data["grandTotals"])
                    this.grandTotals!.push(FieldGrandTotal.fromJS(item));
            }
            this.exceptionMessage = _data["exceptionMessage"];
        }
    }

    static fromJS(data: any): GetAllPaymentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllPaymentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        data["dataAsOf"] = this.dataAsOf;
        if (Array.isArray(this.locations)) {
            data["locations"] = [];
            for (let item of this.locations)
                data["locations"].push(item.toJSON());
        }
        if (Array.isArray(this.blAndGrpcLogger)) {
            data["blAndGrpcLogger"] = [];
            for (let item of this.blAndGrpcLogger)
                data["blAndGrpcLogger"].push(item);
        }
        if (Array.isArray(this.grandTotals)) {
            data["grandTotals"] = [];
            for (let item of this.grandTotals)
                data["grandTotals"].push(item.toJSON());
        }
        data["exceptionMessage"] = this.exceptionMessage;
        return data; 
    }
}

export interface IGetAllPaymentsResponse {
    payments: ViewHistoryPayment[];
    dataAsOf: string;
    locations: ComboBoxItemUuidValue[];
    blAndGrpcLogger: string[];
    grandTotals: FieldGrandTotal[];
    exceptionMessage: string;
}

export class Status implements IStatus {
    code!: number;
    message!: string;
    details!: Any[];

    constructor(data?: IStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.message = _data["message"];
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(Any.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Status {
        data = typeof data === 'object' ? data : {};
        let result = new Status();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["message"] = this.message;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data; 
    }
}

export interface IStatus {
    code: number;
    message: string;
    details: Any[];
}

export class ViewHistoryPayment implements IViewHistoryPayment {
    id!: string;
    legalEntityName!: string;
    locationName!: string;
    vendorName!: string;
    billNumber!: string;
    billDate!: string;
    billDescription!: string;
    invoiceAmount!: number;
    discount!: number;
    amountRemaining!: number;
    paymentAmount!: number;
    paymentMethodName!: string;
    invoiceImageURL!: string;
    checkNumber!: string;
    checkAmount!: number;
    paymentDate!: string;
    paymentNumber!: string;
    hasClearedCheckImages!: boolean;
    processorPaymentId!: string;
    paymentExceptionDate!: string;
    paymentExceptionDescription!: string;
    dueDate!: string;
    fileDate!: string;
    disbursementStatusId!: number;
    disbursementStatusName!: string;
    archimedesDocumentId!: string;
    bankAccountName!: string;
    voidableState!: number;

    constructor(data?: IViewHistoryPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.legalEntityName = _data["legalEntityName"];
            this.locationName = _data["locationName"];
            this.vendorName = _data["vendorName"];
            this.billNumber = _data["billNumber"];
            this.billDate = _data["billDate"];
            this.billDescription = _data["billDescription"];
            this.invoiceAmount = _data["invoiceAmount"];
            this.discount = _data["discount"];
            this.amountRemaining = _data["amountRemaining"];
            this.paymentAmount = _data["paymentAmount"];
            this.paymentMethodName = _data["paymentMethodName"];
            this.invoiceImageURL = _data["invoiceImageURL"];
            this.checkNumber = _data["checkNumber"];
            this.checkAmount = _data["checkAmount"];
            this.paymentDate = _data["paymentDate"];
            this.paymentNumber = _data["paymentNumber"];
            this.hasClearedCheckImages = _data["hasClearedCheckImages"];
            this.processorPaymentId = _data["processorPaymentId"];
            this.paymentExceptionDate = _data["paymentExceptionDate"];
            this.paymentExceptionDescription = _data["paymentExceptionDescription"];
            this.dueDate = _data["dueDate"];
            this.fileDate = _data["fileDate"];
            this.disbursementStatusId = _data["disbursementStatusId"];
            this.disbursementStatusName = _data["disbursementStatusName"];
            this.archimedesDocumentId = _data["archimedesDocumentId"];
            this.bankAccountName = _data["bankAccountName"];
            this.voidableState = _data["voidableState"];
        }
    }

    static fromJS(data: any): ViewHistoryPayment {
        data = typeof data === 'object' ? data : {};
        let result = new ViewHistoryPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["legalEntityName"] = this.legalEntityName;
        data["locationName"] = this.locationName;
        data["vendorName"] = this.vendorName;
        data["billNumber"] = this.billNumber;
        data["billDate"] = this.billDate;
        data["billDescription"] = this.billDescription;
        data["invoiceAmount"] = this.invoiceAmount;
        data["discount"] = this.discount;
        data["amountRemaining"] = this.amountRemaining;
        data["paymentAmount"] = this.paymentAmount;
        data["paymentMethodName"] = this.paymentMethodName;
        data["invoiceImageURL"] = this.invoiceImageURL;
        data["checkNumber"] = this.checkNumber;
        data["checkAmount"] = this.checkAmount;
        data["paymentDate"] = this.paymentDate;
        data["paymentNumber"] = this.paymentNumber;
        data["hasClearedCheckImages"] = this.hasClearedCheckImages;
        data["processorPaymentId"] = this.processorPaymentId;
        data["paymentExceptionDate"] = this.paymentExceptionDate;
        data["paymentExceptionDescription"] = this.paymentExceptionDescription;
        data["dueDate"] = this.dueDate;
        data["fileDate"] = this.fileDate;
        data["disbursementStatusId"] = this.disbursementStatusId;
        data["disbursementStatusName"] = this.disbursementStatusName;
        data["archimedesDocumentId"] = this.archimedesDocumentId;
        data["bankAccountName"] = this.bankAccountName;
        data["voidableState"] = this.voidableState;
        return data; 
    }
}

export interface IViewHistoryPayment {
    id: string;
    legalEntityName: string;
    locationName: string;
    vendorName: string;
    billNumber: string;
    billDate: string;
    billDescription: string;
    invoiceAmount: number;
    discount: number;
    amountRemaining: number;
    paymentAmount: number;
    paymentMethodName: string;
    invoiceImageURL: string;
    checkNumber: string;
    checkAmount: number;
    paymentDate: string;
    paymentNumber: string;
    hasClearedCheckImages: boolean;
    processorPaymentId: string;
    paymentExceptionDate: string;
    paymentExceptionDescription: string;
    dueDate: string;
    fileDate: string;
    disbursementStatusId: number;
    disbursementStatusName: string;
    archimedesDocumentId: string;
    bankAccountName: string;
    voidableState: number;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}